import React, { useState } from 'react';
import { Carousel } from 'antd';
import './Services.scss';

import bgHair   from '../assets/images/bg_hair.png';
import bgBridal from '../assets/images/bg_Bridal.png';
import bgSkin   from '../assets/images/bg_skinfacial.png';
import bgSpa    from '../assets/images/bg_spa.png';
import bgColor  from '../assets/images/bg_color.png';

const servicesData = [
  {
    title: 'Hair Styling & Cutting',
    subtitle: 'Fresh looks for every occasion',
    description: 'Precision cuts, blow-dries and styling tailored to your face shape and lifestyle. From everyday elegance to event-ready glam.',
    tag: 'Most Popular',
    bgImage: bgHair,
  },
  {
    title: 'Bridal & Party Makeup',
    subtitle: 'Flawless glam that lasts all day',
    description: 'HD makeup, long-wear foundation and fully customized looks for brides and special occasions. You deserve to shine.',
    tag: 'Bridal Special',
    bgImage: bgBridal,
  },
  {
    title: 'Skin & Facial Care',
    subtitle: 'Glow from within',
    description: 'Deep cleansing facials, tan removal and glow treatments using safe, premium products suited to every skin type.',
    tag: 'Skin Care',
    bgImage: bgSkin,
  },
  {
    title: 'Hand, Feet & Spa',
    subtitle: 'Relax, renew, refresh',
    description: 'Luxury manicure, pedicure and spa rituals designed to restore, pamper and leave you feeling brand new.',
    tag: 'Spa & Wellness',
    bgImage: bgSpa,
  },
  {
    title: 'Hair Coloring',
    subtitle: 'Vibrant shades & trends',
    description: 'Custom colour treatments, highlights, balayage and ammonia-free options — colour that turns heads.',
    tag: 'Colour Specialist',
    bgImage: bgColor,
  },
];

const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <section
      className="services-section"
      aria-label="Our Services"
      style={{ backgroundImage: `url(${servicesData[currentSlide].bgImage})` }}
    >
      <div className="services-section__overlay" />

      <div className="services-wrap">
        <div className="services-header">
          <span className="services-kicker">What We Offer</span>
          <h2 className="services-title">Enhance your beauty, effortlessly</h2>
          <p className="services-subtitle">
            Five signature services, one destination — crafted around you.
          </p>
        </div>

        <Carousel
          autoplay
          autoplaySpeed={3500}
          dots
          dotPosition="bottom"
          className="services-carousel"
          effect="fade"
          pauseOnHover
          afterChange={setCurrentSlide}
        >
          {servicesData.map((service, idx) => (
            <div key={idx}>
              <div className="service-card">
                <span className="service-tag">{service.tag}</span>
                <h3 className="service-name">{service.title}</h3>
                <p className="service-sub">{service.subtitle}</p>
                <p className="service-desc">{service.description}</p>
                <button
                  className="service-cta"
                  onClick={() => {
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Book Now <span aria-hidden>→</span>
                </button>
              </div>
            </div>
          ))}
        </Carousel>

        {/* Slide indicators (text) */}
        <div className="services-names">
          {servicesData.map((s, i) => (
            <span key={i} className={i === currentSlide ? 'active' : ''}>{s.tag}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
